import type { IStreamFormData } from "../../../types/streams";

/**
 * Append the selected package + services as the `package_item[...]` snapshot,
 * the same contract booking-add uses. The backend builds/updates this stream's
 * own PackageItem from these keys (see stream full-create / full-update).
 *
 * Base services from the package and any additional services chosen in the
 * stream flow are merged and de-duplicated into `package_item[services][]`.
 */
export const appendStreamPackageItem = (
  formData: FormData,
  streamForm: IStreamFormData,
): void => {
  const pkg = streamForm.package;
  if (!pkg) return;

  formData.append("package_item[name]", pkg.name);
  formData.append(
    "package_item[description]",
    pkg.contents?.[0] || pkg.name,
  );
  formData.append("package_item[package]", String(pkg.id));
  formData.append("package_item[price]", Number(pkg.price ?? 0).toFixed(2));

  const baseServiceIds = (pkg.base_services ?? []).map((s) => s.id);
  const additionalIds = streamForm.package_service_ids ?? [];
  const uniqueIds = Array.from(new Set([...baseServiceIds, ...additionalIds]));
  uniqueIds.forEach((id) => {
    formData.append("package_item[services][]", String(id));
  });
};
